import axios, {
  AxiosError,
  AxiosRequestHeaders,
  AxiosResponseHeaders,
} from "axios";
import {
  clearCredentials,
  redirectToHissa,
  revalidateAuth,
} from "../components/utils";
import {
  useAuthStore,
  useAuthorizationStore,
  useCompanyStore,
  usePermissionStore,
} from "../store";

const clearStores = () => {
  useAuthStore.getState().clear();
  useAuthorizationStore.getState().clearAuthorization();
  useCompanyStore.getState().clearCompanyData();
  usePermissionStore.getState().clearPermission();
};
const optionsApi = axios.create({
  baseURL:
    sessionStorage.getItem("esopNodeApi") ||
    process.env.REACT_APP_OPTIONS_API ||
    "http://localhost:4000",
});
optionsApi.defaults.headers.post["Content-Type"] = "application/json";
optionsApi.defaults.headers.common["Access-Control-Expose-Headers"] =
  "companyId";
optionsApi.interceptors.request.use((config) => {
  const accesstoken = useAuthStore.getState().accessToken;
  revalidateAuth();
  if (accesstoken && !config.url?.endsWith("/login")) {
    const companyId =
      sessionStorage.getItem("companyId") ||
      useCompanyStore.getState().companyData?.id ||
      "";
    (config.headers as AxiosRequestHeaders).Authorization = accesstoken;
    if (companyId) {
      (config.headers as AxiosRequestHeaders).companyId = companyId;
    }
  }
  return config;
});
optionsApi.interceptors.response.use((res) => {
  if (
    !sessionStorage.getItem("companyId") &&
    (res.headers as AxiosResponseHeaders)?.companyId
  ) {
    sessionStorage.setItem(
      "companyId",
      (res.headers as AxiosResponseHeaders).companyId
    );
  }
  return res;
});

export default optionsApi;
